import React, { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import _round from 'lodash/round';
import _pickBy from 'lodash/pickBy';
import _isUndefined from 'lodash/isUndefined';

import Portal from 'components/Portal';
import MenuItem from './components/MenuItem';

import './style.scss';

export default class ReorderMenu extends PureComponent {
  static propTypes = {
    model: PropTypes.shape({
      id: PropTypes.string,
      order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isOpen: PropTypes.bool,
    isGrouped: PropTypes.bool,
    onClose: PropTypes.func,
    reorderItem: PropTypes.func,
    mode: PropTypes.string,
    orderList: PropTypes.arrayOf(
      PropTypes.shape({
        index: PropTypes.number,
        order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ),
  };

  static defaultProps = {
    isGrouped: false,
  };

  state = {
    position: {},
  };

  componentDidMount() {
    if (this.reorderRef.current) {
      this.getPosition(this.reorderRef.current);
    }

    if (this.listRef.current) {
      this.handleScroll(this.listRef.current, this.props.index - 1);
    }
  }

  componentDidUpdate(prevProps) {
    const { index, isOpen } = this.props;
    // Call handleScroll if index changes
    if (prevProps.index !== index && this.listRef.current) {
      this.handleScroll(this.listRef.current, index - 1);
    }

    // Call handleScroll if isOpen changed from false to true
    if (!prevProps.isOpen && isOpen) {
      this.getPosition(this.reorderRef.current);
      this.handleScroll(this.listRef.current, index - 1);
    }
  }

  getPosition = domElement => {
    const { mode } = this.props;
    const { top, left } = domElement.getBoundingClientRect();

    const docHeight = document.documentElement.offsetHeight;

    const newTop =
      docHeight - 100 > top
        ? `${_round(top)}px`
        : `${_round(docHeight) - 100}px`;

    const obj = {
      list: newTop,
      input: `${_round(top + 130)}px`,
    };

    this.setState({
      position: {
        top: obj[mode],
        left: `${_round(left)}px`,
      },
    });
  };

  reorderRef = React.createRef();
  listRef = React.createRef();

  /* eslint-disable react/no-find-dom-node, camelcase */
  handleScroll = (domElement, index) => {
    const item = 28;
    const list = 130;
    findDOMNode(domElement).scrollTop = item * index - (list / 2 - item / 2);
  };

  handleDropUndefined = obj => _pickBy(obj, i => !_isUndefined(i));

  handleReorder = (order, index) => {
    const {
      reorderItem,
      model: { id, rule_group },
      mode,
      onClose,
      isGrouped,
    } = this.props;

    const group = !_isUndefined(rule_group) ? rule_group : null;
    const newId = !_isUndefined(rule_group) && !isGrouped ? rule_group : id;

    if (mode === 'list') {
      reorderItem(newId, { order: index }, group, 'move');
    } else {
      reorderItem(order);
    }

    onClose();
  };

  render() {
    const {
      model: { order },
      isGrouped,
      orderList,
      onClose,
      isOpen,
    } = this.props;
    const strOrder = order.toString();
    const len = orderList.length;

    return (
      <div styleName="menu" ref={this.reorderRef}>
        {isOpen && (
          <Portal onOutsideClick={onClose} onEscapeClick={onClose}>
            <div
              styleName="options"
              style={this.state.position}
              data-test="reorder-menu"
            >
              <div styleName="first-last">
                <MenuItem
                  order={orderList[0].order}
                  index={orderList[0].index}
                  label="First"
                  isDisabled={strOrder === orderList[0].order || len === 0}
                  onReorder={this.handleReorder}
                />
                <MenuItem
                  order={orderList[len - 1].order}
                  index={orderList[len - 1].index}
                  label="Last"
                  isDisabled={
                    strOrder === orderList[len - 1].order || len === 0
                  }
                  onReorder={this.handleReorder}
                />
              </div>
              <div styleName="list" ref={this.listRef} data-test="reorder-list">
                {orderList.map(item => (
                  <MenuItem
                    key={item.index}
                    index={item.index}
                    order={item.order}
                    isGrouped={isGrouped}
                    isActive={strOrder === item.order}
                    onReorder={this.handleReorder}
                  />
                ))}
              </div>
            </div>
          </Portal>
        )}
      </div>
    );
  }
}
